export const LOGIN_DEFAULT_ROUTE_CONFIG_KEY =
  "frontend.login_default_route";
export const FALLBACK_LOGIN_DEFAULT_ROUTE = "/workbench";

const ROUTE_BASE_URL = "https://agent-client.invalid";

function isAuthRoute(pathname: string): boolean {
  return (
    pathname === "/login" ||
    pathname.startsWith("/login/") ||
    pathname === "/register" ||
    pathname.startsWith("/register/")
  );
}

export function normalizeLoginDefaultRoute(value: unknown): string | null {
  if (typeof value !== "string") return null;

  const route = value.trim();
  if (!route.startsWith("/")) return null;

  try {
    const parsed = new URL(route, ROUTE_BASE_URL);
    if (
      parsed.origin !== ROUTE_BASE_URL ||
      parsed.pathname === "/" ||
      isAuthRoute(parsed.pathname)
    ) {
      return null;
    }

    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return null;
  }
}

export function resolveLoginDefaultRoute(value: unknown): string {
  return normalizeLoginDefaultRoute(value) ?? FALLBACK_LOGIN_DEFAULT_ROUTE;
}

export function getLoginNavigationOptions(href: string) {
  // 插件与帮助文档是独立静态站，不能交给主应用路由匹配，需整页跳转。
  return {
    href,
    reloadDocument:
      href.startsWith("/plugin-apps/") || href.startsWith("/help-docs"),
  };
}
